<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2909_12897)">
      <path
        d="M1.47998 14.1641V17.4097C1.47998 18.4557 2.32835 19.304 3.37436 19.304H16.7386C17.7846 19.304 18.633 18.4557 18.633 17.4097V14.2515"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M10.0955 14.971V2.26562"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M10.0698 14.9712L4.37451 9.27734"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M10.1211 14.9712L15.8163 9.27734"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2909_12897">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.785156)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
